import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllOperatory } from '@services/api/operatory.api'
import { IOperatory } from '@dataTypes/appointment.type'

export const fetchAllOperatories = createAsyncThunk<IOperatory[], void>(
  'operatory/fetchAllOperatories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllOperatory()

      // Check if we got valid real data
      if (
        response.statusCode === 200 &&
        response.data &&
        'operatories' in response.data &&
        Array.isArray(response.data.operatories)
      ) {
        const operatories = response.data.operatories as IOperatory[]

        // If we have real operatories, return ONLY real data (never mix with mock)
        if (operatories.length > 0) {
          return operatories
        }

        return []
      }

      return rejectWithValue(response.message || 'Failed to fetch operatories')
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An error occurred',
      )
    }
  },
)
